import PropTypes from 'prop-types';
import { useCallback, useState } from "react";
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import ActionDropdown from '../common/components/ActionDropdown';
import Icon from '../common/components/Icon';
import useClientConfig from "../common/hooks/clientConfigHook";
import { useRealizationContext } from '../common/reducers/utilities';
import { TextPromptDialog } from "../common/utils/dialogUtlities";
import { printJob } from "../utils/jobPrinting";
import useNetwork from '../common/hooks/networkHook';

export const JobPrintButton = ({ jobid}) => {
    const { t, i18n } = useTranslation();
    const network = useNetwork();
    const realizationContext = useRealizationContext();
    const clientConfig = useClientConfig();
    const [printPending, setPrintPending] = useState(false);
    const [excludeStruckNotes, setExcludeStruckNotes] = useState(false);
    const [printingTemplate, setPrintingTemplate] = useState();
    
    const print = useCallback(async (reason) => {
        const { blob, filename } = await printJob(i18n, realizationContext, reason, jobid, { excludeStruckNotes, templateDoc: printingTemplate});
        network.downloadBlob(blob, filename);
    }, [i18n, realizationContext, jobid, excludeStruckNotes, printingTemplate, network])
    const handlePrintMenu = useCallback((exclude = false, template = null) => {
        setExcludeStruckNotes(exclude);
        setPrintingTemplate(template ?? undefined);
        setPrintPending(true);
    }, []);

    return <>
        <TextPromptDialog title={t('confirmPrinting')} message={t('jobPrintReason')} maxLength={256} showModal={!!printPending} placeholder={t('reason')} onClose={reason => { setPrintPending(false); reason && print(reason) }}></TextPromptDialog>
        { clientConfig.download_access?.jobs !== false && <ActionDropdown id={`job-print-${jobid ?? "new"}`} label={t('print')} icon={<Icon intent="print"></Icon>}>
            <Dropdown.Item onClick={() => handlePrintMenu(false)}>{t('print')}</Dropdown.Item>
            <Dropdown.Item onClick={() => handlePrintMenu(true)}>{t('print')} {t('excludeStruckNotes')}</Dropdown.Item>
            {clientConfig.customJobForms && clientConfig.customJobForms.map(f => <Dropdown.Item key={f.name} onClick={() => handlePrintMenu(false, f)}>{f.name}</Dropdown.Item>)}
        </ActionDropdown> }
    </>
}

JobPrintButton.propTypes = {
    jobid: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}